import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { apiCall } from '../utils/apiService';

const MyProfileLayer = () => {
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [user, setUser] = useState({});
    const [password, setPassword] = useState('');
    const [alertMessage, setAlertMessage] = useState('');

    useEffect(() => {
        document.title = "Update Profile";
        const myProfile = JSON.parse(localStorage.getItem('user'));
        setUser(myProfile);
        if (myProfile?.image) {
            setImagePreviewUrl(`${process.env.REACT_APP_FILE_URL}/profile/${myProfile.image}`);
        }
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', user.name);
        formData.append('email', user.email);
        if (password) formData.append('newpass', password);
        if (selectedFile) formData.append('file', selectedFile);

        try {
            const response = await apiCall({
                url: 'user/update-profile',
                method: 'POST',
                body: formData,
                withoutStringify: true
            });

            if (response.success) {
                setAlertMessage({ message: response.msg, class: 'success' });
                const updatedUser = {
                    ...user,
                    name: user.name,
                    email: user.email,
                    ...(response.user || {}),
                };
                if (response.image) {
                    updatedUser.image = response.image;
                }
                localStorage.setItem('user', JSON.stringify(updatedUser));
                setUser(updatedUser);
                if (response.image) {
                    setImagePreviewUrl(`${process.env.REACT_APP_FILE_URL}/profile/${response.image}`);
                }
                setPassword('');
            } else {
                setAlertMessage({ message: response.msg, class: 'danger' });
            }
        } catch (err) {
            console.error(err);
            setAlertMessage({ message: err.message, class: 'danger' });
        }
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8 col-lg-10">
                        {
                            alertMessage && (
                                <div className={`alert alert-${alertMessage.class}`} style={{ fontSize: '12px' }}>
                                    {alertMessage.message}
                                </div>
                            )
                        }
                        <div className="card border">
                            <div className="card-body">
                                <h6 className="text-md text-primary-light mb-16">Profile Image</h6>

                                {/* Upload Image */}
                                <div className="mb-24 mt-16">
                                    <div className="avatar-upload">
                                        <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                                            <input
                                                type="file"
                                                id="imageUpload"
                                                accept=".png, .jpg, .jpeg"
                                                hidden
                                                onChange={handleImageChange}
                                            />
                                            <label
                                                htmlFor="imageUpload"
                                                className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-success-50 text-success-600 border border-success-600 bg-hover-success-100 text-lg rounded-circle">
                                                <Icon icon="solar:camera-outline" className="icon" />
                                            </label>
                                        </div>
                                        <div className="avatar-preview">
                                            <div
                                                id="imagePreview"
                                                style={{
                                                    backgroundImage: `url(${imagePreviewUrl})`,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Profile Form */}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-20">
                                        <label htmlFor="name" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            Full Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="name"
                                            name="name"
                                            value={user?.name || ''}
                                            onChange={handleInputChange}
                                            placeholder="Enter Full Name"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label htmlFor="email" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control radius-8"
                                            id="email"
                                            name="email"
                                            value={user?.email || ''}
                                            onChange={handleInputChange}
                                            placeholder="Enter email address"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label htmlFor="password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            Password
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control radius-8"
                                            id="password"
                                            name="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="Enter new password"
                                        />
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <button type="button" className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8">
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-success border border-success-600 text-md px-56 py-12 radius-8">
                                            Save
                                        </button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfileLayer;
